import { Paging } from 'api/inc-api.types';
import {
  AssignTransactionResult,
  DepositsSummary,
  GeneratePayoutDetails,
  Transaction,
} from '../transactions.types';

export const customerTransactionData: {
  transactions: Transaction[];
  paging: Paging;
} = {
  transactions: [
    {
      id: '6fd6762b-e339-4f28-8e35-dc3f63bbdaa7',
      extTxId: 'cd2020ee-5248-42ca-9152-113b29e7ee04',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-06-28',
      txDateTime: '2023-06-28T02:11:24',
      openedDate: '2023-06-30T04:35:00',
      closedDate: null,
      modifiedDate: '2023-06-28T06:11:24',
      fullFilDate: '2023-06-30T04:35:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-06-29T06:45:05',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: 'b045fa2d-f74d-4c5e-8919-26afeda60e4c',
          openedDate: '2023-06-30T00:35:00',
          closedDate: null,
          modifiedDate: '2023-06-28T02:11:24',
          deletedDate: null,
          deleted: false,
          displayNumber: '3',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              itemName: 'French Onion',
              displayName:
                'French onion - really long name and too many characters',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 10500,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 660,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 50,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 710,
              total: 10500,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'FORHERE',
              displayName: 'FORHERE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '3fa0ddc9-da7e-47be-bcdc-c4a23a4504bc',
              itemName: 'Rice',
              displayName: 'Rice',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '0d4f5cef-9494-481c-ab5a-bf7439f6a02d',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 8600,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 540,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 40,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 580,
              total: 8600,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 20390,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 1290,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 19100,
            total: 20390,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1234',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-06-29T06:45:10',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 1290,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 19100,
        total: 20390,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-06-30T08:48:19',
      txCreatedDate: '2023-06-29T06:45:08',
      txModifiedDate: '2023-06-28T06:11:24',
    },
    {
      id: '67bff0b5-f723-4767-9ed0-9ba33cbaffc6',
      extTxId: '243a874c-b046-495e-bb74-6b04514e4c9c',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-12',
      txDateTime: '2023-05-12T15:30:21',
      openedDate: '2023-05-13T04:05:00',
      closedDate: null,
      modifiedDate: '2023-05-12T19:30:21',
      fullFilDate: '2023-05-13T04:05:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-15T12:32:16',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '022b3635-3e4a-4cab-91aa-22b9b6a451be',
          openedDate: '2023-05-13T00:05:00',
          closedDate: null,
          modifiedDate: '2023-05-12T15:30:21',
          deletedDate: null,
          deleted: false,
          displayNumber: '21',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: 'ab678076-c983-48f3-a795-dce921d477d7',
              itemName: 'Honey BBQ Test',
              displayName: 'Honey BBQ Test',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 3550,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 220,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 20,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 240,
              total: 3550,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'FORHERE - 1212, TEST ORDER DO NOT PREPARE',
              displayName: 'FORHERE - 1212, TEST ORDER DO NOT PREPARE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              itemName: 'French Onion',
              displayName: 'French Onion',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 16710,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1040,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 80,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1120,
              total: 16710,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 21620,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [
            {
              offerId: null,
              extOfferId: '74a5232e-c98a-4306-8573-7881a799a3df',
              distributedOfferId: null,
              offerCode: null,
              name: 'OPEN Discount for Universal offers',
              discountType: null,
              appliedDiscount: 0,
              additionalAttribs: null,
            },
          ],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 1360,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 20260,
            total: 21620,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-15T12:32:23',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 1360,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 20260,
        total: 21620,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-18T04:25:43',
      txCreatedDate: '2023-05-15T12:32:21',
      txModifiedDate: '2023-05-12T19:30:21',
    },
    {
      id: '58695bd5-05f5-48d1-b5bb-ad937d56853b',
      extTxId: 'a3b9dde4-9a48-4b60-94e5-9057d41af156',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-11',
      txDateTime: '2023-05-11T17:30:00',
      openedDate: '2023-05-11T21:30:00',
      closedDate: null,
      modifiedDate: '2023-05-11T07:45:44',
      fullFilDate: '2023-05-11T21:30:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-29T07:44:00',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '92f3359d-d9ab-4b9d-a715-c8a6ec78330f',
          openedDate: '2023-05-11T17:30:00',
          closedDate: null,
          modifiedDate: '2023-05-11T03:45:44',
          deletedDate: null,
          deleted: false,
          displayNumber: '3',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: '7d17053f-2834-46a9-8955-8f9fb73d4b10',
              itemName: 'Salad',
              displayName: 'Salad',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 1000,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 0,
                  percentage: 5.0,
                  appliedTax: 0,
                },
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 60,
                  percentage: 62.5,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 60,
              total: 1000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '7d17053f-2834-46a9-8955-8f9fb73d4b10',
              itemName: 'Salad',
              displayName: 'Salad',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 3000,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 20,
                  percentage: 5.0,
                  appliedTax: 0,
                },
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 190,
                  percentage: 62.5,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 210,
              total: 3000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'FORHERE - 456',
              displayName: 'FORHERE - 456',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 4270,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 270,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 4000,
            total: 4270,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-29T07:44:08',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 270,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 4000,
        total: 4270,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-29T07:44:08',
      txCreatedDate: '2023-05-29T07:44:05',
      txModifiedDate: '2023-05-11T07:45:44',
    },
    {
      id: '5885002b-a458-4d39-a7d2-1934b5311360',
      extTxId: '95652ba3-b601-4cee-9242-547e90d5773a',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-11',
      txDateTime: '2023-05-11T17:00:00',
      openedDate: '2023-05-11T21:00:00',
      closedDate: null,
      modifiedDate: '2023-05-09T10:12:37',
      fullFilDate: '2023-05-11T21:00:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-29T07:44:00',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '49ee3776-f0e6-4f87-89eb-54caf2069199',
          openedDate: '2023-05-11T17:00:00',
          closedDate: null,
          modifiedDate: '2023-05-09T06:12:37',
          deletedDate: null,
          deleted: false,
          displayNumber: '2',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              itemName: 'French Onion',
              displayName: 'French Onion',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 17010,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1060,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 90,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1150,
              total: 17010,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              itemName: 'Chicken Noodle check Auto import',
              displayName: 'Chicken Noodle check Auto import',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 18890,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 90,
                  percentage: 5.0,
                  appliedTax: 0,
                },
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1180,
                  percentage: 62.5,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1270,
              total: 18890,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'DRIVETHRU - , TEST ORDER DO NOT PREPARE',
              displayName: 'DRIVETHRU - , TEST ORDER DO NOT PREPARE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 42310,
              gratuity: 9580,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [
            {
              chargeId: null,
              extChargeId: 'b1cee43f-38eb-441e-8ece-439f465369b0',
              chargeDescription: 'delivery charge',
              chargeType: 'FIXED',
              appliedCharge: 3990,
              percentage: null,
              taxable: false,
              gratuity: true,
              delivery: true,
              appliedTax: [],
            },
          ],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 9580,
            tax: 2420,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 3990,
            dicountTotal: 0,
            subTotal: 35900,
            total: 51890,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '0714979672',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-29T07:44:08',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 9580,
        tax: 2420,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 3990,
        dicountTotal: 0,
        subTotal: 35900,
        total: 51890,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-29T07:44:08',
      txCreatedDate: '2023-05-29T07:44:04',
      txModifiedDate: '2023-05-09T10:12:37',
    },
    {
      id: 'a01b3960-e1c4-4f87-9493-6bba458b4760',
      extTxId: 'eac33c75-f0a7-4d7e-bde4-df88ee9fd611',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-11',
      txDateTime: '2023-05-11T07:30:00',
      openedDate: '2023-05-11T11:30:00',
      closedDate: null,
      modifiedDate: '2023-05-11T10:30:34',
      fullFilDate: '2023-05-11T11:30:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-29T07:44:11',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '9d274580-6ca4-4ef9-b290-5961bc54f4f1',
          openedDate: '2023-05-11T07:30:00',
          closedDate: null,
          modifiedDate: '2023-05-11T06:30:34',
          deletedDate: null,
          deleted: false,
          displayNumber: '18',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: '2b2564ea-1756-499e-b8db-a09b77c1c040',
              itemName: 'Ice cream',
              displayName: 'Ice cream',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 10000,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 620,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 50,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 670,
              total: 10000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName:
                'DRIVETHRU - , TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE',
              displayName:
                'DRIVETHRU - , TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE TEST ORDER DO NOT PREPARE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '9a4ce369-bee2-4d74-a374-ceeeda1ee06f',
              itemName: 'Coffee',
              displayName: 'Coffee',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 6000,
              quantity: 2,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 60,
                  percentage: 5.0,
                  appliedTax: 0,
                },
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 760,
                  percentage: 62.5,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 820,
              total: 12000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 27480,
              gratuity: 530,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [
            {
              chargeId: null,
              extChargeId: 'cefa0415-c3bb-4f03-91db-1adf5d11e5af',
              chargeDescription: 'delivery charge',
              chargeType: 'FIXED',
              appliedCharge: 3990,
              percentage: null,
              taxable: false,
              gratuity: true,
              delivery: true,
              appliedTax: [],
            },
          ],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 530,
            tax: 1490,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 3990,
            dicountTotal: 0,
            subTotal: 22000,
            total: 28010,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-29T07:44:16',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 530,
        tax: 1490,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 3990,
        dicountTotal: 0,
        subTotal: 22000,
        total: 28010,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-29T07:44:16',
      txCreatedDate: '2023-05-29T07:44:15',
      txModifiedDate: '2023-05-11T10:30:34',
    },
    {
      id: 'ee28f827-5715-4c21-8041-820c3a7c3868',
      extTxId: 'fc9e5e5b-19a8-4ff0-8495-e48a2d1fd5bc',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-11',
      txDateTime: '2023-05-11T06:28:00',
      openedDate: '2023-05-11T10:28:00',
      closedDate: '2023-05-11T10:28:00',
      modifiedDate: '2023-05-11T10:28:00',
      fullFilDate: null,
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-29T07:44:10',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: 'c30a9c59-7199-4acf-9efa-76ae8176459d',
          openedDate: '2023-05-11T06:28:00',
          closedDate: '2023-05-11T06:28:00',
          modifiedDate: '2023-05-11T06:28:00',
          deletedDate: null,
          deleted: false,
          displayNumber: '17',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: '9a4ce369-bee2-4d74-a374-ceeeda1ee06f',
              itemName: 'Coffee',
              displayName: 'Coffee',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 9000,
              quantity: 3,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 120,
                  percentage: 5.0,
                  appliedTax: 0,
                },
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1680,
                  percentage: 62.5,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1800,
              total: 27000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '2b2564ea-1756-499e-b8db-a09b77c1c040',
              itemName: 'Ice cream',
              displayName: 'Ice cream',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 21500,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1340,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 110,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1450,
              total: 21500,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '9a4ce369-bee2-4d74-a374-ceeeda1ee06f',
              itemName: 'Coffee',
              displayName: 'Coffee',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 19000,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1190,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 100,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1290,
              total: 19000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'FORHERE',
              displayName: 'FORHERE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '2a8aa6b8-bfb3-4628-838a-34d4c92ed72a',
              itemName: 'Fruit Juice',
              displayName: 'Fruit Juice',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 11000,
              quantity: 2,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1380,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 120,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1500,
              total: 22000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 95540,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 6040,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 89500,
            total: 95540,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-29T07:44:16',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 6040,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 89500,
        total: 95540,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-29T07:44:16',
      txCreatedDate: '2023-05-29T07:44:14',
      txModifiedDate: '2023-05-11T10:28:00',
    },
    {
      id: '4f8a9f96-0713-4467-bfd2-ddb9793be6b5',
      extTxId: '2fc52045-b9d6-45c8-bc28-17f532bb6af5',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-10',
      txDateTime: '2023-05-10T23:59:59',
      openedDate: '2023-05-11T07:53:16',
      closedDate: '2023-05-11T07:53:16',
      modifiedDate: '2023-05-11T07:53:16',
      fullFilDate: null,
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-29T08:08:03',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '93119a75-f13d-497a-a3a7-e74e706e52c3',
          openedDate: '2023-05-11T03:53:16',
          closedDate: '2023-05-11T03:53:16',
          modifiedDate: '2023-05-11T03:53:16',
          deletedDate: null,
          deleted: false,
          displayNumber: '24',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'FORHERE',
              displayName: 'FORHERE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '2b2564ea-1756-499e-b8db-a09b77c1c040',
              itemName: 'Ice cream',
              displayName: 'Ice cream',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '2e05f56b-5ac1-4f7f-b107-5ea2dc3b936f',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 10000,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 620,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 50,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 670,
              total: 10000,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 10670,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 670,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 10000,
            total: 10670,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-29T08:08:08',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 670,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 10000,
        total: 10670,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-29T08:08:08',
      txCreatedDate: '2023-05-29T08:08:06',
      txModifiedDate: '2023-05-11T07:53:16',
    },
    {
      id: 'a6c59592-484f-4d90-8c99-3a537f2fa299',
      extTxId: '2d2af460-e7d6-40e8-985c-7d2034d58d7a',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-05-09',
      txDateTime: '2023-05-09T06:35:00',
      openedDate: '2023-05-09T10:35:00',
      closedDate: null,
      modifiedDate: '2023-05-09T10:11:53',
      fullFilDate: '2023-05-09T10:35:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-05-10T05:08:57',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      storeName: "Fenway - QA  (Don't Use)",
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '1ab3ccfd-f739-44f0-9415-021b28ed48dd',
          openedDate: '2023-05-09T06:35:00',
          closedDate: null,
          modifiedDate: '2023-05-09T06:11:53',
          deletedDate: null,
          deleted: false,
          displayNumber: '8',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'INSTORE - , TEST ORDER DO NOT PREPARE',
              displayName: 'INSTORE - , TEST ORDER DO NOT PREPARE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              itemName: 'Chicken Noodle check Auto import',
              displayName: 'Chicken Noodle check Auto import',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 18890,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1180,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 90,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1270,
              total: 18890,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              itemName: 'French Onion',
              displayName: 'French Onion',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 17010,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1060,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 90,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1150,
              total: 17010,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 38320,
              gratuity: 9580,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 9580,
            tax: 2420,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 35900,
            total: 47900,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani',
            lastName: 'Subasinghe',
            email: 'aetqatest10@gmail.com',
            phoneNo: '0714979672',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-05-10T05:09:09',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 9580,
        tax: 2420,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 35900,
        total: 47900,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-05-10T07:48:08',
      txCreatedDate: '2023-05-10T05:09:04',
      txModifiedDate: '2023-05-09T10:11:53',
    },
    {
      id: 'ff760b56-2dcd-4029-8e2b-11b5c1e95e77',
      extTxId: '796ccb1e-63dc-4110-8443-00693d4c2172',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-03-29',
      txDateTime: '2023-03-29T06:20:00',
      openedDate: '2023-03-29T10:20:00',
      closedDate: null,
      modifiedDate: '2023-03-29T09:28:43',
      fullFilDate: '2023-03-29T10:20:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-03-30T06:07:17',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '66955a44-3a27-4720-9878-918d502c788a',
      storeName: 'FENWAY - Balsamic Toast Store - Test',
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '20dc1ae7-d9ec-4e55-9ec6-aaac0cadcf3c',
          openedDate: '2023-03-29T06:20:00',
          closedDate: null,
          modifiedDate: '2023-03-29T05:28:43',
          deletedDate: null,
          deleted: false,
          displayNumber: '9',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'CURBSIDE - TEST ORDER DO NOT PREPARE',
              displayName: 'CURBSIDE - TEST ORDER DO NOT PREPARE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              itemName: 'French Onion',
              displayName: 'French Onion',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 17760,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1110,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 90,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1200,
              total: 17760,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 18960,
              gratuity: 950,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 950,
            tax: 1200,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 17760,
            total: 19910,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-03-30T06:07:17',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 950,
        tax: 1200,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 17760,
        total: 19910,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-03-30T06:30:19',
      txCreatedDate: '2023-03-30T06:07:17',
      txModifiedDate: '2023-03-29T09:28:43',
    },
    {
      id: 'eadf2c5c-a957-46cc-ad2e-12ebc0728aa8',
      extTxId: 'daf9c6a4-156b-4638-95e4-d5749572a536',
      importBatchId: null,
      displayNumber: null,
      businessDate: '2023-03-28',
      txDateTime: '2023-03-28T04:10:00',
      openedDate: '2023-03-28T08:10:00',
      closedDate: null,
      modifiedDate: '2023-03-28T06:56:08',
      fullFilDate: '2023-03-28T08:10:00',
      deleted: false,
      deletedDate: null,
      txZoneId: 'America/New_York',
      importedDate: '2023-03-28T13:20:18',
      transactionType: 'sale',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      storeId: '66955a44-3a27-4720-9878-918d502c788a',
      storeName: 'FENWAY - Balsamic Toast Store - Test',
      extStoreId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      customerId: null,
      extCustId: null,
      loyaltyId: null,
      extLoyaltyId: null,
      loyaltyNumber: null,
      posId: null,
      laneId: null,
      employeeId: null,
      employeeName: null,
      appliedDiscounts: null,
      checks: [
        {
          checkId: '442cd385-ac0f-4ab2-a42b-55e700222472',
          openedDate: '2023-03-28T04:10:00',
          closedDate: null,
          modifiedDate: '2023-03-28T02:56:08',
          deletedDate: null,
          deleted: false,
          displayNumber: '1',
          orderItems: [
            {
              orderItemId: null,
              itemId: null,
              extItemId: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              itemName: 'Chicken Noodle',
              displayName: 'Chicken Noodle',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 18890,
              quantity: 2,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 2360,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 180,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 2540,
              total: 37780,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: null,
              itemName: 'INSTORE',
              displayName: 'INSTORE',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: null,
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 0,
              quantity: 1,
              appliedDiscounts: [],
              appliedTax: [],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 0,
              total: 0,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
            {
              orderItemId: null,
              itemId: null,
              extItemId: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              itemName: 'Chicken Noodle',
              displayName: 'Chicken Noodle',
              instructions: null,
              sku: null,
              upc: null,
              catalogId: null,
              extCatalogId: null,
              groupId: null,
              extGroupId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
              brandId: null,
              extBrandId: null,
              categoryId: null,
              extCategoryId: null,
              uom: null,
              modifiers: null,
              unitPrice: 11890,
              quantity: 2,
              appliedDiscounts: [],
              appliedTax: [
                {
                  taxId: '018ae7c1-224d-4fe6-b5ea-4f712c9b647d',
                  taxDescription: 'State Tax',
                  taxType: 'PERCENT',
                  amount: 1480,
                  percentage: 62.5,
                  appliedTax: 0,
                },
                {
                  taxId: 'f9e1e6cf-eb0a-4716-951e-cca7988e1fa4',
                  taxDescription: 'Delivery Tax',
                  taxType: 'PERCENT',
                  amount: 120,
                  percentage: 5.0,
                  appliedTax: 0,
                },
              ],
              preDiscountItemTotal: 0,
              dicountTotal: 0,
              taxTotal: 1600,
              total: 23780,
              voided: false,
              voidInfo: null,
              createdDate: null,
              modifiedDate: null,
              notes: null,
            },
          ],
          payments: [
            {
              amount: 65700,
              gratuity: 0,
              tenderType: 'OTHER',
              cardType: null,
              last4: null,
              paymentStatus: 'CAPTURED',
              voided: false,
              voidInfo: null,
              refundStatus: 'NONE',
              refund: null,
            },
          ],
          appliedCharges: [],
          appliedDiscounts: [],
          total: {
            itemTotal: 0,
            gratuity: 0,
            tax: 4140,
            taxedChargeTotal: 0,
            nonTaxedChargeTotal: 0,
            dicountTotal: 0,
            subTotal: 61560,
            total: 65700,
            paid: 0,
            due: 0,
            processingFee: 0,
          },
          paymentStatus: null,
          voided: false,
          voidInfo: {
            voidDate: null,
            voidBusinessDate: null,
            voidReason: null,
          },
          customer: {
            incentivioId: '57e8e415-d107-4828-a2bb-abd4e0a714eb',
            extId: '7269058f-4b9d-4cdc-ab83-02fc32e30df2',
            firstName: 'Heshani Laknilu',
            lastName: 'Subasinghe1',
            email: 'aetqatest10@gmail.com',
            phoneNo: '5087401100',
          },
          loyaltyStatus: 'SUCCESS',
          loyaltyStatusModifiedTime: '2023-03-28T13:20:20',
          loyaltyUnSuccessfulReason: null,
          loyaltyUnSuccessfulAdditionalInfo: null,
          customerResolved: true,
        },
      ],
      loyaltyPoints: null,
      total: {
        itemTotal: 0,
        gratuity: 0,
        tax: 4140,
        taxedChargeTotal: 0,
        nonTaxedChargeTotal: 0,
        dicountTotal: 0,
        subTotal: 61560,
        total: 65700,
        paid: 0,
        due: 0,
        processingFee: 0,
      },
      paymentStatus: null,
      voided: false,
      voidInfo: {
        voidDate: null,
        voidBusinessDate: null,
        voidReason: null,
      },
      refundStatus: null,
      refund: null,
      source: 'API',
      extendedAttribs: null,
      loyaltyStatus: 'SUCCESS',
      loyaltyStatusModifiedTime: '2023-03-29T08:02:36',
      txCreatedDate: '2023-03-28T13:20:19',
      txModifiedDate: '2023-03-28T06:56:08',
    },
  ],
  paging: {
    total: 39,
    count: 10,
    totalPages: 4,
    currentPage: 0,
  },
};

export const depositsSummaryData: {
  content: DepositsSummary[];
  paging: Paging;
} = {
  content: [
    {
      payoutId: 'payout_id_1',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      amount: 1340,
      currency: 'usd',
      status: 'paid',
      type: 'bank_account',
      bankName: 'STRIPE TEST BANK',
      bankLastFour: '6789',
      expectedDate: '2024-02-21T00:00:00Z',
      paidDate: '2024-02-21T00:00:00Z',
      createdDate: '2022-10-16T01:03:17Z',
      stripeBody:
        '{"amount":134,"arrival_date":1708473600,"automatic":true,"balance_transaction":{"id":"txn_1Om4DRQKILVC4wUmmAX84DCE"},"created":1708477397,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1LmKd2QKILVC4wUmldNQL2MO"},"id":"po_1Om4DRQKILVC4wUmLWFyYy3n","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
    {
      payoutId: 'payout_id_2',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1MMrkb4CWJdvqrps',
      amount: 2600,
      currency: 'usd',
      status: 'pending',
      type: 'bank_account',
      bankName: 'STRIPE TEST BANK',
      bankLastFour: '6789',
      expectedDate: '2024-02-20T00:00:00Z',
      paidDate: '2024-02-20T00:00:00Z',
      createdDate: '2022-10-17T01:03:17Z',
      stripeBody:
        '{"amount":260,"arrival_date":1708387200,"automatic":true,"balance_transaction":{"id":"txn_1OlLv34CWJdvqrpsNxitd3Ee"},"created":1708307120,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1MMrwG4CWJdvqrpsu2eVJqz3"},"id":"po_1OlLv24CWJdvqrpspyKdGKkk","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
    {
      payoutId: 'payout_id_3',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      amount: 1340,
      currency: 'usd',
      status: 'in_transit',
      type: 'bank_account',
      bankName: 'STRIPE TEST BANK',
      bankLastFour: '6789',
      expectedDate: '2024-02-20T00:00:00Z',
      paidDate: '2024-02-20T00:00:00Z',
      createdDate: '2022-10-15T01:03:17Z',
      stripeBody:
        '{"amount":134,"arrival_date":1708387200,"automatic":true,"balance_transaction":{"id":"txn_1OlLKhQKILVC4wUm85tQUVmw"},"created":1708304867,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1LmKd2QKILVC4wUmldNQL2MO"},"id":"po_1OlLKhQKILVC4wUmZNiOFOuv","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
    {
      payoutId: 'payout_id_4',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      amount: 1340,
      currency: 'usd',
      status: 'cancelled',
      type: 'bank_account',
      bankName: 'STRIPE TEST BANK',
      bankLastFour: '6789',
      expectedDate: '2024-02-20T00:00:00Z',
      paidDate: '2024-02-20T00:00:00Z',
      createdDate: '2022-10-14T01:03:17Z',
      stripeBody:
        '{"amount":134,"arrival_date":1708387200,"automatic":true,"balance_transaction":{"id":"txn_1OlLKhQKILVC4wUm85tQUVmw"},"created":1708304867,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1LmKd2QKILVC4wUmldNQL2MO"},"id":"po_1OlLKhQKILVC4wUmZNiOFOuv","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
    {
      payoutId: 'payout_id_5',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      amount: 1340,
      currency: 'usd',
      status: 'failed',
      type: 'card',
      bankName: 'STRIPE TEST BANK',
      bankLastFour: '6789',
      expectedDate: '2024-02-20T00:00:00Z',
      paidDate: '2024-02-20T00:00:00Z',
      createdDate: '2022-10-13T01:03:17Z',
      stripeBody:
        '{"amount":134,"arrival_date":1708387200,"automatic":true,"balance_transaction":{"id":"txn_1OlLKhQKILVC4wUm85tQUVmw"},"created":1708304867,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1LmKd2QKILVC4wUmldNQL2MO"},"id":"po_1OlLKhQKILVC4wUmZNiOFOuv","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
    {
      payoutId: 'payout_id_6',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      amount: 1342,
      currency: 'usd',
      status: 'failed',
      type: 'card',
      bankName: '',
      bankLastFour: '6789',
      expectedDate: '2024-02-20T00:00:00Z',
      paidDate: '2024-02-20T00:00:00Z',
      createdDate: '22022-10-12T01:03:17Z',
      stripeBody:
        '{"amount":134,"arrival_date":1708387200,"automatic":true,"balance_transaction":{"id":"txn_1OlLKhQKILVC4wUm85tQUVmw"},"created":1708304867,"currency":"usd","description":"STRIPE PAYOUT","destination":{"id":"ba_1LmKd2QKILVC4wUmldNQL2MO"},"id":"po_1OlLKhQKILVC4wUmZNiOFOuv","livemode":false,"metadata":{},"method":"standard","object":"payout","source_type":"card","status":"paid","type":"bank_account"}',
    },
  ],
  paging: {
    count: 10,
    currentPage: 0,
    total: 3,
    totalPages: 1,
  },
};

export const generateSucceededDetailsData: GeneratePayoutDetails = {
  reportRunId: 'frr_1OwoM64F7mT5XQKcyYQIQl5p',
  clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
  adminId: '0261ddbc-3fd3-405d-ba6b-a993a66fc158',
  payoutId: 'po_1OnW9Y4F7mT5XQKcHiNzfRBp',
  stripeAccountId: 'acct_1MrEL14F7mT5XQKc',
  status: 'succeeded',
  results: {
    fileId: 'file_1OwoMK4F7mT5XQKclQ2hbO00',
    fileLink:
      'https://files.stripe.com/links/MDB8YWNjdF8xTXJFTDE0RjdtVDVYUUtjfGZsX3Rlc3Rfbzc0cEt5VUFSYVUwVW01OG10STFpUVNJ00wPeG8W1p',
  },
  expiresAt: '2025-03-21T16:20:52Z',
  createdDate: '2024-03-21T16:20:38.454Z',
};

export const generatePendingDetailsData: GeneratePayoutDetails = {
  reportRunId: 'frr_1OwoM64F7mT5XQKcyYQIQl5p',
  clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
  adminId: '0261ddbc-3fd3-405d-ba6b-a993a66fc158',
  payoutId: 'po_1OnW9Y4F7mT5XQKcHiNzfRBp',
  stripeAccountId: 'acct_1MrEL14F7mT5XQKc',
  status: 'pending',
  expiresAt: '2025-03-21T16:20:52Z',
  createdDate: '2024-03-21T16:20:38.454Z',
};

export const assignTransactionResult: AssignTransactionResult = {
  extTxnId: '6fd6762b-e339-4f28-8e35-dc3f63bbdaa7',
  message: 'Successfully Assigned Transaction',
};
